<p>user-vehicule-details-scores works!</p>
